"use client";

const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

interface AlphabetNavProps {
  activeLetter: string | null;
  onLetterClick: (letter: string) => void;
  onClearFilter: () => void;
}

export default function AlphabetNav({
  activeLetter,
  onLetterClick,
  onClearFilter,
}: AlphabetNavProps) {
  return (
    <nav className="mb-8 backdrop-blur-sm py-4 border-y border-line relative">
      {activeLetter && (
        <button
          onClick={onClearFilter}
          className="block mx-auto mb-3 px-3 py-1.5 text-xs bg-theme-light/20 text-theme-light rounded-full hover:bg-theme-light/30 transition-colors font-medium sm:absolute sm:left-4 sm:top-1/2 sm:-translate-y-1/2 sm:mb-0"
        >
          Clear filter
        </button>
      )}
      <div className="flex flex-wrap justify-center gap-1 sm:gap-2 items-center">
        {alphabet.map((letter) => (
          <button
            key={letter}
            onClick={() => onLetterClick(letter)}
            className={`
              w-8 h-8 sm:w-10 sm:h-10 rounded-md font-bold text-sm sm:text-base
              transition-all duration-200
              ${
                activeLetter === letter
                  ? "bg-ink text-inverse scale-110"
                  : "bg-surface-raised text-muted hover:bg-surface-hover hover:text-ink"
              }
            `}
          >
            {letter}
          </button>
        ))}
      </div>
    </nav>
  );
}
